"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.treatmentMessages = exports.metastasesMessages = exports.nodesMessages = exports.tumourMessages = exports.typeMessages = exports.hasDiseaseMessages = exports.Treatment = exports.Metastases = exports.Nodes = exports.Tumour = exports.Type = exports.HasDisease = void 0;
const schema_1 = require("../../../../schema");
var HasDisease;
(function (HasDisease) {
    HasDisease["HAS_ONCOLOGY_DISEASE"] = "has_oncology_disease";
    HasDisease["NO_UNKNOWN_ONCOLOGY_DISEASE"] = "no_unknown_oncology_disease";
})(HasDisease || (exports.HasDisease = HasDisease = {}));
var Type;
(function (Type) {
    Type["CEREBRUM_ONCOLOGY_DISEASE"] = "cerebrum_oncology_disease";
    Type["LIPS_ONCOLOGY_DISEASE"] = "lips_oncology_disease";
    Type["AMYLOIDOSIS_ONCOLOGY_DISEASE"] = "amyloidosis_oncology_disease";
    Type["SKIN_TUMOUR_ONCOLOGY_DISEASE"] = "skin_tumour_oncology_disease";
    Type["CERVIX_UTERI_ONCOLOGY_DISEASE"] = "cervix_uteri_oncology_disease";
    Type["CORPUS_UTERI_ONCOLOGY_DISEASE"] = "corpus_uteri_oncology_disease";
    Type["NEOPLASMS_OF_BONE_MARROW_ONCOLOGY_DISEASE"] = "neoplasms_of_bone_marrow_oncology_disease";
    Type["MAMMA_ONCOLOGY_DISEASE"] = "mamma_oncology_disease";
    Type["CHOLECYSTA_PANCREAS_ONCOLOGY_DISEASE"] = "cholecysta_pancreas_oncology_disease";
    Type["LARYNX_ONCOLOGY_DISEASE"] = "larynx_oncology_disease";
    Type["VENTRICULUS_ONCOLOGY_DISEASE"] = "ventriculus_oncology_disease";
    Type["HODGKIN_DISEASE"] = "hodgkin_disease";
    Type["URETHRA_MALIGNANCY_ONCOLOGY_DISEASE"] = "urethra_malignancy_oncology_disease";
    Type["KAPOSI_SARCOMA_ONCOLOGY_DISEASE"] = "kaposi_sarcoma_oncology_disease";
    Type["CONNECTIVE_TISSUE_ONCOLOGY_DISEASE"] = "connective_tissue_oncology_disease";
    Type["LEUKAEMIA_ONCOLOGY_DISEASE"] = "leukaemia_oncology_disease";
    Type["MELANOMA_ONCOLOGY_DISEASE"] = "melanoma_oncology_disease";
    Type["MESOTHELIOMA_ONCOLOGY_DISEASE"] = "mesothelioma_oncology_disease";
    Type["MULTIPLE_MYELOMA_ONCOLOGY_DISEASE"] = "multiple_myeloma_oncology_disease";
    Type["NON_HODGKIN_DISEASE"] = "non_hodgkin_disease";
    Type["GLANDULA_SALIVARIS_ONCOLOGY_DISEASE"] = "glandula_salivaris_oncology_disease";
    Type["OESOPHAGUS_ONCOLOGY_DISEASE"] = "oesophagus_oncology_disease";
    Type["TOUNG_ONCOLOGY_DISEASE"] = "toung_oncology_disease";
    Type["OVARIUM_ONCOLOGY_DISEASE"] = "ovarium_oncology_disease";
    Type["GLANDULA_THYROIDA_ONCOLOGY_DISEASE"] = "glandula_thyroida_oncology_disease";
    Type["PENIS_ONCOLOGY_DISEASE"] = "penis_oncology_disease";
    Type["PROSTATA_ONCOLOGY_DISEASE"] = "prostata_oncology_disease";
    Type["MOUTH_ONCOLOGY_DISEASE"] = "mouth_oncology_disease";
    Type["EYES_ONCOLOGY_DISEASE"] = "eyes_oncology_disease";
    Type["TESTIS_ONCOLOGY_DISEASE"] = "testis_oncology_disease";
    Type["TRACHEA_BRONCHUS_BRONCHII_ONCOLOGY_DISEASE"] = "trachea_bronchus_bronchii_oncology_disease";
    Type["LUNG_ONCOLOGY_DISEASE"] = "lung_oncology_disease";
    Type["URETERAL_MALIGNANCY_ONCOLOGY_DISEASE"] = "ureteral_malignancy_oncology_disease";
    Type["RENAL_MALIGNANCY_ONCOLOGY_DISEASE"] = "renal_malignancy_oncology_disease";
    Type["SMALL_INTESTINE_ONCOLOGY_DISEASE"] = "small_intestine_oncology_disease";
    Type["VULVA_ONCOLOGY_DISEASE"] = "vulva_oncology_disease";
})(Type || (exports.Type = Type = {}));
var Tumour;
(function (Tumour) {
    Tumour["ZERO"] = "zero";
    Tumour["ONE"] = "one";
    Tumour["TWO"] = "two";
    Tumour["THREE"] = "three";
    Tumour["FOUR"] = "four";
    Tumour["X"] = "x";
})(Tumour || (exports.Tumour = Tumour = {}));
var Nodes;
(function (Nodes) {
    Nodes["ZERO"] = "zero";
    Nodes["ONE"] = "one";
    Nodes["TWO"] = "two";
    Nodes["X"] = "x";
})(Nodes || (exports.Nodes = Nodes = {}));
var Metastases;
(function (Metastases) {
    Metastases["ZERO"] = "zero";
    Metastases["ONE"] = "one";
    Metastases["TWO"] = "two";
    Metastases["X"] = "x";
})(Metastases || (exports.Metastases = Metastases = {}));
var Treatment;
(function (Treatment) {
    Treatment["CHEMOTHERAPY"] = "chemotherapy";
    Treatment["IRRADIATION"] = "irradiation";
    Treatment["SURGERY"] = "surgery";
})(Treatment || (exports.Treatment = Treatment = {}));
exports.hasDiseaseMessages = {
    [HasDisease.HAS_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.hasDisease.HAS_ONCOLOGY_DISEASE",
        defaultMessage: "Diagnosztizált onkológiai betegség"
    },
    [HasDisease.NO_UNKNOWN_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.hasDisease.NO_UNKNOWN_ONCOLOGY_DISEASE",
        defaultMessage: "Nincs vagy nem ismert"
    }
};
exports.typeMessages = {
    [Type.CEREBRUM_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.CEREBRUM_ONCOLOGY_DISEASE",
        defaultMessage: "Agy onkológiai betegsége"
    },
    [Type.LIPS_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.LIPS_ONCOLOGY_DISEASE",
        defaultMessage: "Ajak onkológiai betegsége"
    },
    [Type.AMYLOIDOSIS_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.AMYLOIDOSIS_ONCOLOGY_DISEASE",
        defaultMessage: "Amyloidosis"
    },
    [Type.SKIN_TUMOUR_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.SKIN_TUMOUR_ONCOLOGY_DISEASE",
        defaultMessage: "Bőr egyéb rosszindulatú daganata"
    },
    [Type.CERVIX_UTERI_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.CERVIX_UTERI_ONCOLOGY_DISEASE",
        defaultMessage: "Cervix uteri"
    },
    [Type.CORPUS_UTERI_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.CORPUS_UTERI_ONCOLOGY_DISEASE",
        defaultMessage: "Corpus uteri"
    },
    [Type.NEOPLASMS_OF_BONE_MARROW_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.NEOPLASMS_OF_BONE_MARROW_ONCOLOGY_DISEASE",
        defaultMessage: "Csontvelő egyéb rosszindulatú daganata"
    },
    [Type.MAMMA_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.MAMMA_ONCOLOGY_DISEASE",
        defaultMessage: "Emlő onkológiai betegsége"
    },
    [Type.CHOLECYSTA_PANCREAS_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.CHOLECYSTA_PANCREAS_ONCOLOGY_DISEASE",
        defaultMessage: "Epehólyag onkológiai betegsége"
    },
    [Type.LARYNX_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.LARYNX_ONCOLOGY_DISEASE",
        defaultMessage: "Gége onkológiai betegsége"
    },
    [Type.VENTRICULUS_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.VENTRICULUS_ONCOLOGY_DISEASE",
        defaultMessage: "Gyomor onkológiai betegsége"
    },
    [Type.HODGKIN_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.HODGKIN_DISEASE",
        defaultMessage: "Hodgkin betegség"
    },
    [Type.URETHRA_MALIGNANCY_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.URETHRA_MALIGNANCY_ONCOLOGY_DISEASE",
        defaultMessage: "Húgyhólyag / Húgycső daganat"
    },
    [Type.KAPOSI_SARCOMA_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.KAPOSI_SARCOMA_ONCOLOGY_DISEASE",
        defaultMessage: "Kaposi sarcoma"
    },
    [Type.CONNECTIVE_TISSUE_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.CONNECTIVE_TISSUE_ONCOLOGY_DISEASE",
        defaultMessage: "Kötőszöveti és más lágyszövet onkológiai betegsége"
    },
    [Type.LEUKAEMIA_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.LEUKAEMIA_ONCOLOGY_DISEASE",
        defaultMessage: "Leukaemia"
    },
    [Type.MELANOMA_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.MELANOMA_ONCOLOGY_DISEASE",
        defaultMessage: "Melanoma"
    },
    [Type.MESOTHELIOMA_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.MESOTHELIOMA_ONCOLOGY_DISEASE",
        defaultMessage: "Mesothelioma"
    },
    [Type.MULTIPLE_MYELOMA_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.MULTIPLE_MYELOMA_ONCOLOGY_DISEASE",
        defaultMessage: "Myeloma multiplex"
    },
    [Type.NON_HODGKIN_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.NON_HODGKIN_DISEASE",
        defaultMessage: "Non Hodgkin lymphoma"
    },
    [Type.GLANDULA_SALIVARIS_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.GLANDULA_SALIVARIS_ONCOLOGY_DISEASE",
        defaultMessage: "Nyálmirigy onkológiai betegsége"
    },
    [Type.OESOPHAGUS_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.OESOPHAGUS_ONCOLOGY_DISEASE",
        defaultMessage: "Nyelőcső onkológiai betegsége"
    },
    [Type.TOUNG_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.TOUNG_ONCOLOGY_DISEASE",
        defaultMessage: "Nyelv onkológiai betegsége"
    },
    [Type.OVARIUM_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.OVARIUM_ONCOLOGY_DISEASE",
        defaultMessage: "Ovarium onkológiai betegsége"
    },
    [Type.GLANDULA_THYROIDA_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.GLANDULA_THYROIDA_ONCOLOGY_DISEASE",
        defaultMessage: "Pajzsmirigy onkológiai betegsége"
    },
    [Type.PENIS_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.PENIS_ONCOLOGY_DISEASE",
        defaultMessage: "Penis onkológiai betegsége"
    },
    [Type.PROSTATA_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.PROSTATA_ONCOLOGY_DISEASE",
        defaultMessage: "Prostata onkológiai betegsége"
    },
    [Type.MOUTH_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.MOUTH_ONCOLOGY_DISEASE",
        defaultMessage: "Száj onkológiai betegsége"
    },
    [Type.EYES_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.EYES_ONCOLOGY_DISEASE",
        defaultMessage: "Szem onkológiai betegsége"
    },
    [Type.TESTIS_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.TESTIS_ONCOLOGY_DISEASE",
        defaultMessage: "Testis onkológiai betegsége"
    },
    [Type.TRACHEA_BRONCHUS_BRONCHII_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.TRACHEA_BRONCHUS_BRONCHII_ONCOLOGY_DISEASE",
        defaultMessage: "Trachea / Bronchus / Bronchii"
    },
    [Type.LUNG_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.LUNG_ONCOLOGY_DISEASE",
        defaultMessage: "Tüdő onkológiai betegsége"
    },
    [Type.URETERAL_MALIGNANCY_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.URETERAL_MALIGNANCY_ONCOLOGY_DISEASE",
        defaultMessage: "Ureter daganat"
    },
    [Type.RENAL_MALIGNANCY_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.RENAL_MALIGNANCY_ONCOLOGY_DISEASE",
        defaultMessage: "Vese rosszindulatú daganata"
    },
    [Type.SMALL_INTESTINE_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.SMALL_INTESTINE_ONCOLOGY_DISEASE",
        defaultMessage: "Vékonybél onkológiai betegsége (ileum, jejunum, colon, rectum, anus)"
    },
    [Type.VULVA_ONCOLOGY_DISEASE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.type.VULVA_ONCOLOGY_DISEASE",
        defaultMessage: "Vulva onkológiai betegsége"
    }
};
exports.tumourMessages = {
    [Tumour.ZERO]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.tumour.ZERO",
        defaultMessage: "0"
    },
    [Tumour.ONE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.tumour.ONE",
        defaultMessage: "1"
    },
    [Tumour.TWO]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.tumour.TWO",
        defaultMessage: "2"
    },
    [Tumour.THREE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.tumour.THREE",
        defaultMessage: "3"
    },
    [Tumour.FOUR]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.tumour.FOUR",
        defaultMessage: "4"
    },
    [Tumour.X]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.tumour.X",
        defaultMessage: "x"
    }
};
exports.nodesMessages = {
    [Nodes.ZERO]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.nodes.ZERO",
        defaultMessage: "0"
    },
    [Nodes.ONE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.nodes.ONE",
        defaultMessage: "1"
    },
    [Nodes.TWO]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.nodes.TWO",
        defaultMessage: "2"
    },
    [Nodes.X]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.nodes.X",
        defaultMessage: "x"
    }
};
exports.metastasesMessages = {
    [Metastases.ZERO]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.metastases.ZERO",
        defaultMessage: "0"
    },
    [Metastases.ONE]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.metastases.ONE",
        defaultMessage: "1"
    },
    [Metastases.TWO]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.metastases.TWO",
        defaultMessage: "2"
    },
    [Metastases.X]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.metastases.X",
        defaultMessage: "x"
    }
};
exports.treatmentMessages = {
    [Treatment.CHEMOTHERAPY]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.treatment.CHEMOTHERAPY",
        defaultMessage: "Kemoterápia"
    },
    [Treatment.IRRADIATION]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.treatment.IRRADIATION",
        defaultMessage: "Irradiáció"
    },
    [Treatment.SURGERY]: {
        id: "ktx.transplantationScreening.medicalHistory.oncologyDiseases.treatment.SURGERY",
        defaultMessage: "Műtéti"
    }
};
const hasDisease = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HasDisease.HAS_ONCOLOGY_DISEASE).interpretation({
        vocab: "ktx",
        code: "has_oncology_disease"
    }),
    schema_1.Schema.singleChoiceItem(HasDisease.NO_UNKNOWN_ONCOLOGY_DISEASE)
        .interpretation({ vocab: "ktx", code: "no_unknown_oncology_disease" })
        .tag({ vocab: "ktx", code: "oncology_disease_type" })
]).interpretation({ vocab: "ktx", code: "has_oncology_disease_choice" });
const type = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Type.CEREBRUM_ONCOLOGY_DISEASE)
        .interpretation({ vocab: "ktx", code: "cerebrum_oncology_disease" })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.LIPS_ONCOLOGY_DISEASE)
        .interpretation({ vocab: "ktx", code: "lips_oncology_disease" })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.AMYLOIDOSIS_ONCOLOGY_DISEASE)
        .interpretation({ vocab: "ktx", code: "amyloidosis_oncology_disease" })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.SKIN_TUMOUR_ONCOLOGY_DISEASE)
        .interpretation({ vocab: "ktx", code: "skin_tumour_oncology_disease" })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.CERVIX_UTERI_ONCOLOGY_DISEASE)
        .interpretation({ vocab: "ktx", code: "cervix_uteri_oncology_disease" })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.CORPUS_UTERI_ONCOLOGY_DISEASE)
        .interpretation({ vocab: "ktx", code: "corpus_uteri_oncology_disease" })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.NEOPLASMS_OF_BONE_MARROW_ONCOLOGY_DISEASE)
        .interpretation({
        vocab: "ktx",
        code: "neoplasms_of_bone_marrow_oncology_disease"
    })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.MAMMA_ONCOLOGY_DISEASE)
        .interpretation({ vocab: "ktx", code: "mamma_oncology_disease" })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.CHOLECYSTA_PANCREAS_ONCOLOGY_DISEASE)
        .interpretation({
        vocab: "ktx",
        code: "cholecysta_pancreas_oncology_disease"
    })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.LARYNX_ONCOLOGY_DISEASE)
        .interpretation({ vocab: "ktx", code: "larynx_oncology_disease" })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.VENTRICULUS_ONCOLOGY_DISEASE)
        .interpretation({ vocab: "ktx", code: "ventriculus_oncology_disease" })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.HODGKIN_DISEASE)
        .interpretation({ vocab: "ktx", code: "hodgkin_disease" })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.URETHRA_MALIGNANCY_ONCOLOGY_DISEASE)
        .interpretation({
        vocab: "ktx",
        code: "urethra_malignancy_oncology_disease"
    })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.KAPOSI_SARCOMA_ONCOLOGY_DISEASE)
        .interpretation({
        vocab: "ktx",
        code: "kaposi_sarcoma_oncology_disease"
    })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.CONNECTIVE_TISSUE_ONCOLOGY_DISEASE)
        .interpretation({
        vocab: "ktx",
        code: "connective_tissue_oncology_disease"
    })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.LEUKAEMIA_ONCOLOGY_DISEASE)
        .interpretation({ vocab: "ktx", code: "leukaemia_oncology_disease" })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.MELANOMA_ONCOLOGY_DISEASE)
        .interpretation({ vocab: "ktx", code: "melanoma_oncology_disease" })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.MESOTHELIOMA_ONCOLOGY_DISEASE)
        .interpretation({ vocab: "ktx", code: "mesothelioma_oncology_disease" })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.MULTIPLE_MYELOMA_ONCOLOGY_DISEASE)
        .interpretation({
        vocab: "ktx",
        code: "multiple_myeloma_oncology_disease"
    })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.NON_HODGKIN_DISEASE)
        .interpretation({ vocab: "ktx", code: "non_hodgkin_disease" })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.GLANDULA_SALIVARIS_ONCOLOGY_DISEASE)
        .interpretation({
        vocab: "ktx",
        code: "glandula_salivaris_oncology_disease"
    })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.OESOPHAGUS_ONCOLOGY_DISEASE)
        .interpretation({ vocab: "ktx", code: "oesophagus_oncology_disease" })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.TOUNG_ONCOLOGY_DISEASE)
        .interpretation({ vocab: "ktx", code: "toung_oncology_disease" })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.OVARIUM_ONCOLOGY_DISEASE)
        .interpretation({ vocab: "ktx", code: "ovarium_oncology_disease" })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.GLANDULA_THYROIDA_ONCOLOGY_DISEASE)
        .interpretation({
        vocab: "ktx",
        code: "glandula_thyroida_oncology_disease"
    })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.PENIS_ONCOLOGY_DISEASE)
        .interpretation({ vocab: "ktx", code: "penis_oncology_disease" })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.PROSTATA_ONCOLOGY_DISEASE)
        .interpretation({ vocab: "ktx", code: "prostata_oncology_disease" })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.MOUTH_ONCOLOGY_DISEASE)
        .interpretation({ vocab: "ktx", code: "mouth_oncology_disease" })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.EYES_ONCOLOGY_DISEASE)
        .interpretation({ vocab: "ktx", code: "eyes_oncology_disease" })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.TESTIS_ONCOLOGY_DISEASE)
        .interpretation({ vocab: "ktx", code: "testis_oncology_disease" })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.TRACHEA_BRONCHUS_BRONCHII_ONCOLOGY_DISEASE)
        .interpretation({
        vocab: "ktx",
        code: "trachea_bronchus_bronchii_oncology_disease"
    })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.LUNG_ONCOLOGY_DISEASE)
        .interpretation({ vocab: "ktx", code: "lung_oncology_disease" })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.URETERAL_MALIGNANCY_ONCOLOGY_DISEASE)
        .interpretation({
        vocab: "ktx",
        code: "ureteral_malignancy_oncology_disease"
    })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.RENAL_MALIGNANCY_ONCOLOGY_DISEASE)
        .interpretation({
        vocab: "ktx",
        code: "renal_malignancy_oncology_disease"
    })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.SMALL_INTESTINE_ONCOLOGY_DISEASE)
        .interpretation({
        vocab: "ktx",
        code: "small_intestine_oncology_disease"
    })
        .tag({ vocab: "ktx", code: "oncology_disease_type" }),
    schema_1.Schema.singleChoiceItem(Type.VULVA_ONCOLOGY_DISEASE)
        .interpretation({ vocab: "ktx", code: "vulva_oncology_disease" })
        .tag({ vocab: "ktx", code: "oncology_disease_type" })
])
    .transferInterpretationsAndTagsToParent()
    .expiration(31536000);
const tumour = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Tumour.ZERO),
    schema_1.Schema.singleChoiceItem(Tumour.ONE),
    schema_1.Schema.singleChoiceItem(Tumour.TWO),
    schema_1.Schema.singleChoiceItem(Tumour.THREE),
    schema_1.Schema.singleChoiceItem(Tumour.FOUR),
    schema_1.Schema.singleChoiceItem(Tumour.X)
]);
const nodes = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Nodes.ZERO),
    schema_1.Schema.singleChoiceItem(Nodes.ONE),
    schema_1.Schema.singleChoiceItem(Nodes.TWO),
    schema_1.Schema.singleChoiceItem(Nodes.X)
]);
const metastases = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Metastases.ZERO),
    schema_1.Schema.singleChoiceItem(Metastases.ONE),
    schema_1.Schema.singleChoiceItem(Metastases.TWO),
    schema_1.Schema.singleChoiceItem(Metastases.X)
]);
const grade = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ tumour, nodes, metastases });
const treatment = schema_1.Schema.multiChoice([
    schema_1.Schema.multiChoiceItem(Treatment.CHEMOTHERAPY),
    schema_1.Schema.multiChoiceItem(Treatment.IRRADIATION),
    schema_1.Schema.multiChoiceItem(Treatment.SURGERY)
]).optional();
const diseases = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../hasDisease} === "has_oncology_disease"`), schema_1.Schema.array()
    .default([])
    .minItems(1)
    .items(schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ type, grade, treatment })));
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ hasDisease, diseases });
